import { createContext, useContext } from 'react';

// The action key the host's ⌘↵ runs, so the button that runs it can carry the hint
export const ShortcutRunKeyContext = createContext<string | undefined>(
  undefined
);

export const useShortcutRunKey = () => useContext(ShortcutRunKeyContext);
